import Component from './components/component';
import Download from '../components/download';
import Metadata from '../components/metadata';
import Playlist from './components/playlist';
import Quality from '../components/quality';
import Sharing from '../components/sharing';
import Slider from './components/slider';
import StateButton from './components/state-button';
import Timeline from './components/timeline';
import Volume from './components/volume';
import Marquee from './components/marquee';
import CrossfadeImage from './components/crossfade-image';
import PlaybackControls from './components/playback-controls';
import Adstrip from './components/adstrip';

export default {
  Adstrip,
  Component,
  CrossfadeImage,
  Download,
  Metadata,
  Marquee,
  PlaybackControls,
  Playlist,
  Quality,
  Sharing,
  Slider,
  StateButton,
  Timeline,
  Volume
};
